import React from 'react'
import Flexbox from 'flexbox-react'
import { observer, inject } from 'mobx-react'
import HallPanelShopList from './hall_panel_shop_list'
import grubhubLogo from '../../assets/GH_Logotype_Rebrand_Orange_RGB.svg'
import {GraphikFont} from "../../constants";

const HallPanelDefault = ({ RootStore }) => {
  const { hallStore, styleStore: { currentStylesDict } } = RootStore

  return (
    <Flexbox
      height='100%'
      width='100%'
      flexDirection='column'
      className={currentStylesDict.hallPanelMainBackgroundClassName}
      style={currentStylesDict.hallPanelMainBackgroundColor}
    >
      <Flexbox width='100%' height='4.5%'></Flexbox>
      <Flexbox width='100%' height='9%'>
        <div style={styles.mainLogoStyle}>
          <img src={grubhubLogo} alt='' width='100%' style={{ filter: currentStylesDict['hallPanelLogoFilter'] }} />
        </div>
      </Flexbox>
      <Flexbox width='100%' height='1.7%'></Flexbox>
      <Flexbox height='6.25%' width='100%' flexDirection='column' style={currentStylesDict.shopSidePanelHeader}>
        <Flexbox width='100%' height='100%' style={{ ...styles.hallPanelCourtTitle, color: currentStylesDict.hallPanelCourtTitleColor || 'white' }}>
          <div style={currentStylesDict.hallPanelShopName}>
            {hallStore.foodCourtName}
          </div>
        </Flexbox>
      </Flexbox>
      <Flexbox width='100%' height='3%'></Flexbox>
      <Flexbox width='90%' height='71%' style={styles.shopPanelShopList}>
        <HallPanelShopList />
      </Flexbox>
      <Flexbox width='100%' height='1%'></Flexbox>
      <Flexbox width='100%' height='6%' style={styles.hallPanelShopListNumber}>
        <div style={styles.autoMargin}>
          {hallStore.hallPanelShopListFooter}
        </div>
      </Flexbox>
    </Flexbox>
  )
}

const styles = {
  shopPanelShopList: {
    margin: '0 auto',
    fontSize: '2vh'
  },
  hallPanelShopListNumber: {
    fontSize: '2.8vh',
    fontFamily: GraphikFont.REGULAR,
  },
  autoMargin: {
    margin: 'auto'
  },
  hallPanelCourtTitle: {
    fontSize: '4.2vh',
    fontFamily: GraphikFont.MEDIUM,
  },
  mainLogoStyle: {
    margin: '1% auto',
    width: '45%',
  },
}

export default inject('RootStore')(observer(HallPanelDefault))



// WEBPACK FOOTER //
// ./src/components/shop_panel/hall_panel_default.jsx